import React from 'react';
import './caremanagement.scss';


const CareManagementDropdown = ({ isOpen, onClose, history, movetoContact }) => {
   const careManagementSections = [
      {
         title: 'Care Delivery',
         items: [
            {
               icon: 'paper.png',
               title: 'Care Planning',
               description: 'Person-centred care plans',
               route: '/care-planning'
            },
            {
               icon: 'graph.png',
               title: 'Assessments',
               description: 'Comprehensive assessment tools',
               route: '/assessments'
            },
            {
               icon: 'file.png',
               title: 'Daily Logs',
               description: 'Digital care records & notes',
               route: '/daily_logs'
            },
            {
               icon: 'pharmacy.png',
               title: 'eMAR System',
               description: 'Digital medication records',
               route: '/emar-system'
            }
         ]
      },
      {
         title: 'Scheduling & Operations',
         items: [
            {
               icon: 'calender.png',
               title: 'Visit Rostering',
               description: 'Smart scheduling & shifts',
               route: '/visit-rostering'
            },
            {
               icon: 'location.png',
               title: 'Route Planning',
               description: 'Optimised travel routes',
               route: '/routeplan'
            },
            {
               icon: 'clock.png',
               title: 'Clock In/Out',
               description: 'GPS time tracking',
               route: '/clock-in-out'
            },
            {
               icon: 'receipt.png',
               title: 'Finance & Billing',
               description: 'Invoicing & payroll tools',
               route: '/finance-billing'
            }
         ]
      },
      {
         title: 'Mobile Solutions',
         items: [
            {
               icon: 'mobile-phone.png',
               title: 'Staff App',
               description: 'Offline-capable carer tools',
               route: '/staff-app'
            },
            {
               icon: 'group.png',
               title: 'Family App',
               description: 'Real-time care updates',
               route: '/family-app'
            },
            {
               icon: 'camera.png',
               title: 'Media & Notes',
               description: 'Photos, voice & signatures',
               route: '/media-notes'
            }
         ]
      },
      // {
      //    title: 'Training & Development',
      //    items: [
      //       {
      //          icon: 'presentation.png',
      //          title: 'Care Training',
      //          description: 'Built-in courses & certificates',
      //          route: '/training'
      //       },
      //       {
      //          icon: 'reading-book.png',
      //          title: 'Learning Hub',
      //          description: 'Resources & best practices',
      //          route: '/learning-hub'
      //       },
      //       {
      //          icon: 'trophy.png',
      //          title: 'Skills Matrix',
      //          description: 'Track competencies',
      //          route: '/skills-matrix'
      //       }
      //    ]
      // }
   ];

   const handleItemClick = (route) => {
      history.push(route);
      onClose();
   };

   if (!isOpen) return null;

   return (
      <div
         className="care-management-dropdown-overlay"
         onClick={(e) => e.stopPropagation()} onMouseLeave={onClose}
      >
         <div className="care-management-sections-wrapper">
            {careManagementSections.map((section, sectionIndex) => (
               <div key={sectionIndex} className="care-management-section">
                  <h4 className="care-management-section-title">{section.title}</h4>
                  <div className="care-management-section-items">
                     {section.items.map((item, itemIndex) => (
                        <div
                           key={itemIndex}
                           className="care-management-item"
                           onClick={() => handleItemClick(item.route)}
                        >
                           <div className="care-management-item-icon">
                              <img src={process.env.PUBLIC_URL + `/assets/images/careDaily/${item.icon}`} alt={item.title} width="24px" />
                           </div>
                           <div className="care-management-item-content">
                              <h4>{item.title}</h4>
                              <p>{item.description}</p>
                           </div>
                           <div className="care-management-item-arrow">
                              →
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            ))}
         </div>

         {/* <div className="care-management-dropdown-footer">
            <button
               className="care-management-contact-btn"
               onClick={() => {
                  movetoContact && movetoContact();
                  onClose();
               }}
            >
               Need Help? Contact Us
            </button>
         </div> */}
      </div>
   );
};

export default CareManagementDropdown;